module.exports = __webpack_public_path__ + "img/banner1.edbdc2d2.png";